
// Singleton Integration Client Instances
// These provide configured, ready-to-use clients throughout the application

import { 
  createTextGenerationClient, 
  createAgentsClient,
  createResearchClient 
} from '@/integrations';
import { ThreadedTextGenerationClient } from './openai/threaded-text-generation-client';
import { supabase } from './supabase/client';
import { runwareClient } from './runware/client';
import { cloudinaryClient } from '@/integrations/cloudinary';

// Text Generation Client - for content generation, headers, summaries
export const textGenerationClient = createTextGenerationClient({
  timeout: 60000,    // 60 seconds for text generation
  retries: 2,        // Retry twice on failure
  retryDelay: 1000   // 1 second base delay
});

// AI Agents Client - for conversational AI
export const agentsClient = createAgentsClient({
  timeout: 45000,    // 45 seconds for agent responses
  retries: 0,        // CRITICAL: No retries for OpenAI agents - each call creates a new run
  retryDelay: 1500   // 1.5 second base delay (unused due to retries: 0)
});

// Research Client - for Perplexity research generation
export const researchClient = createResearchClient({
  timeout: 90000,    // 90 seconds (research takes longer)
  retries: 2,        // Retry twice
  retryDelay: 2000   // 2 second base delay
});

// Threaded Text Generation Client - for OpenAI threaded operations
export const threadedTextGenerationClient = new ThreadedTextGenerationClient({
  timeout: 60000,    // 60 seconds for threaded operations
  retries: 0,        // CRITICAL: No retries for threaded operations
  retryDelay: 0      // No delay needed since no retries
});

// Export the initialized clients
export { supabase };
export { runwareClient };

/**
 * Cloudinary client for image upload and management
 * Simplified, reliable interface for all Cloudinary operations
 */
export { cloudinaryClient };

/**
 * All clients in one object for convenience
 */
export const clients = {
  supabase,
  runware: runwareClient,
  cloudinary: cloudinaryClient,
  textGeneration: textGenerationClient,
  agents: agentsClient,
  research: researchClient,
  threadedTextGeneration: threadedTextGenerationClient,
};
